import './public-path';
import 'whatwg-fetch';
import 'custom-event-polyfill';
import 'element-closest/element-closest';
import 'eventlistener-polyfill/src/index';
import "@stimulus/polyfills";

import { JSProtect } from '../shared/security';
import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';
import { registerLazyControllers } from '../shared/controller-registration';
import { installControllerHook } from '../shared/stimulus-test-hook';
import { ChangeLinks } from '../helpers/change-host';
import { initEncapsulatedLoader } from '../helpers/loader-encapsulate';
import hsInputControllerController from "../controllers/hs-input-controller-controller";


JSProtect(() => {
    const application = Application.start();

    installControllerHook(application);

    if (process.env.NODE_ENV !== 'production') {
        window.application = application;
    }

    const lazy_context = require.context('../controllers', true, /^(?!.*hs-input-controller-controller\.js$).*\.js$/, 'lazy');
    
    registerLazyControllers(application, lazy_context);
    application.register('hs-input-controller', hsInputControllerController);
});
